import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { HrOffer, RepositoryModal } from '../../../shared'

@Component({
    templateUrl: './hr-offer.component.html',
    standalone: true,
    imports: [FormsModule, WjInputModule, FaIconComponent],
})
export class HrOfferComponent extends RepositoryModal<HrOffer> {}
